class AtlManuals extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const input = this.querySelector('[data-manual-search]');
    if (!input) return;
    input.closest('label').hidden = false;
    input.addEventListener('input', () => {
      const query = input.value.trim().toLocaleLowerCase(); let found = 0;
      this.querySelectorAll('[data-manual-row]').forEach(row => { row.hidden = !row.textContent.toLocaleLowerCase().includes(query); if (!row.hidden) found++; });
      this.querySelectorAll('[data-manual-group]').forEach(group => { group.hidden = !group.querySelector('[data-manual-row]:not([hidden])'); group.open = Boolean(query) && !group.hidden; });
      this.querySelectorAll('[data-legacy]').forEach(group => { group.hidden = !group.querySelector('[data-manual-row]:not([hidden])'); group.open = Boolean(query) && !group.hidden; });
      this.querySelector('[data-no-results]').hidden = found > 0;
    }, {signal: this.controller.signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('atl-manuals')) customElements.define('atl-manuals', AtlManuals);
